import { Check } from "lucide-react";
import { SeciCycle } from "@/components/home/SeciCycle";
import { Section, SectionHeading, StickerCard } from "@/components/ui";
import { BEYOND } from "@/data/home";

export function BeyondSection() {
  const { seci } = BEYOND;
  return (
    <Section labelledBy="beyond-title" testId="home-beyond">
      <div className="relative z-10">
        <SectionHeading id="beyond-title" title={BEYOND.title} highlight="beyond" intro={BEYOND.intro} />

        <ul className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {BEYOND.items.map((item, i) => (
            <li key={item.id}>
              <StickerCard tone={i % 2 === 0 ? "brandTint" : "sunTint"} className="flex h-full gap-3">
                <span
                  className={`mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${
                    "bg-brand-500 text-white"
                  }`}
                >
                  <Check className="h-4 w-4" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-heading text-xl font-bold leading-tight">{item.title}</h3>
                  <p className="mt-1 text-sm text-ink/70 sm:text-base">{item.text}</p>
                </div>
              </StickerCard>
            </li>
          ))}
        </ul>

        <h3 className="mt-16 font-heading text-2xl font-bold sm:text-4xl">{seci.title}</h3>
        <p className="mt-2 max-w-[56ch] text-base text-ink/70 sm:text-lg">{seci.intro}</p>

        <div className="mt-10">
          <SeciCycle steps={seci.steps} loopLabel={seci.loop} />
        </div>
      </div>
    </Section>
  );
}
